import React from 'react';
import 'rc-color-picker/assets/index.css';
import './color.scss';
import GeckoFieldBase from '../_base.jsx';
import ColorPicker from 'rc-color-picker';

class GeckoFieldColor extends GeckoFieldBase {
  handleChange(event) {
    const color = event.color !== undefined ? event.color : event.target.value;
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(color)
    )();
  }

  pickerValue() {
    const value = this.value();

    if (value && (value.length === 4 || value.length === 7)) {
      return value;
    }
    return null;
  }

  render() {
    return (
      <div className="color-field">
        <input
          id={this.renderId()}
          className="col-sm form-control gecko-ui-material"
          type="text"
          value={this.value()}
          onChange={this.handleChange.bind(this)}
          disabled={this.isDisabled()}
          placeholder={this.config().placeholder}
        />
        <ColorPicker
          color={this.pickerValue()}
          onChange={this.handleChange.bind(this)}
          onClose={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default GeckoFieldColor;
